//
// Change language notification
// ----------------------------

define(function(require, exports, module) {
    'use strict';
    const i18n = require('i18n');
    const core = require('core');

    module.exports = {
        notify: function(message) {
            window.Playtech.API.popup.showPopup({
                title: 'playtech.mobile.system.changeLanguagePopup.changelanguage',
                content: i18n.t(
                    'playtech.mobile.system.changeLanguagePopup.changelanguageto',
                    this.translate('playtech.mobile.system.language.' + message.data.newLang)
                ),
                buttons: [
                    {
                        title: 'playtech.mobile.system.message.ok',
                        onClick: () => core.trigger('user:action:changeLanguage', message.data.newLang)
                    },
                    {
                        title: 'playtech.mobile.system.message.cancel'
                    }
                ]
            });
        }
    };
});
